import { authClient, API } from '../../utils/index';

export const getQuizzes = () => authClient().get(`${API}/quiz`);

export const getQuizById = (id) => authClient().get(`${API}/quiz/${id}`);

export const createQuiz = (data) => authClient().post(`${API}/quiz`, data);

export const updateQuiz = (id, data) => authClient().put(`${API}/quiz/${id}`, data);
